import { Component, OnInit } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ConfigService } from './services/config.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  title = 'business';
  temaPadrao: string = this.configService.getConfig().getTemaPadrao;

  constructor(
    private configService: ConfigService,
    private overlayContainer: OverlayContainer
  ){ }

  ngOnInit(): void {
    this.temaPadrao = this.configService.getConfig().getTemaPadrao;
    this.aplicarTemaNoOverlay(this.temaPadrao);
  }

  // Overlays do Material (datepicker, select, menu, dialog) são anexados ao
  // .cdk-overlay-container no <body>, fora do <div> com [ngClass]="temaPadrao".
  // Sem a classe de tema, a superfície do calendário fica sem background (transparente).
  private aplicarTemaNoOverlay(tema: string): void {
    if (!tema) {
      return;
    }
    this.overlayContainer.getContainerElement().classList.add(tema);
  }
}
